import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import GavelIcon from '@material-ui/icons/Gavel';
import BuildIcon from '@material-ui/icons/Build';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import SecurityIcon from '@material-ui/icons/Security';
import PeopleIcon from '@material-ui/icons/People';

const items = [
  { title: 'Asesoría Jurídica', text: 'Interpretación experta de la Ley de Propiedad Horizontal y justicia administrativa.', Icon: GavelIcon },
  { title: 'Ingeniería y Mantenimiento', text: 'Soluciones para fachadas, impermeabilización, ascensores y sistemas hidráulicos.', Icon: BuildIcon },
  { title: 'Administración y Cobranza', text: 'Estrategias contra la morosidad y optimización de fondos de reserva.', Icon: AccountBalanceIcon },
  { title: 'Innovación en Seguridad', text: 'Tecnología aplicada al resguardo de edificios y control de acceso.', Icon: SecurityIcon },
  { title: 'Convivencia Vecinal', text: 'Mediación de conflictos y fomento de la armonía en comunidad.', Icon: PeopleIcon },
];

const Benefits = () => (
  <Box>
    <Box marginBottom={4}>
      <Typography sx={{ textTransform: 'uppercase', fontWeight: 'medium' }} gutterBottom color="primary" align="center">
        Temas
      </Typography>
      <Box component={Typography} fontWeight={700} variant="h3" gutterBottom align="center" color="primary">
        Un panorama integral
      </Box>
      <Typography align="center" color="textSecondary" variant="h6">
        Dr. Condominio Radio se divide en ejes estratégicos para abordar cada arista de la vida en edificios. Cada tema conecta con una necesidad real de compra.
      </Typography>
    </Box>
    <Grid container spacing={2}>
      {items.map((item, i) => (
        <Grid item xs={12} sm={6} md={4} key={i}>
          <Card variant="outlined" sx={{ height: '100%' }}>
            <CardContent>
              <Box sx={{ mb: 1 }}>
                <item.Icon color="primary" sx={{ fontSize: 28 }} />
              </Box>
              <Typography fontWeight={600} gutterBottom>{item.title}</Typography>
              <Typography variant="body2" color="textSecondary">{item.text}</Typography>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default Benefits;
